module.exports = __webpack_public_path__ + "bg_with-white.pBMF0IIl.svg";